import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export const BREAK_TYPES = [
  { type: "Lunch Break", limit: 45, tone: "#f59e0b", hint: "45 min" },
  { type: "Team Break", limit: 15, tone: "#3b82f6", hint: "15 min" },
  { type: "Short Break", limit: 20, tone: "#10b981", hint: "20 min" },
  { type: "Emergency", limit: null, tone: "#ef4444", hint: "No limit" },
];
export const toneOf = (t) => BREAK_TYPES.find((b) => b.type === t)?.tone || "#64748b";
export const fmtDur = (sec) => {
  const s = Math.max(0, Math.floor(sec || 0)), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), r = s % 60;
  return h ? `${h}h ${String(m).padStart(2, "0")}m` : `${String(m).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
};

const Ctx = createContext(null);
export const useBreak = () => useContext(Ctx);

export function BreakProvider({ user, children }) {
  const staff = ["admin", "sales", "dispatcher"].includes(user?.role);
  const [active, setActive] = useState(null);
  const [busy, setBusy] = useState(false);

  const refresh = useCallback(async () => {
    try { const { data } = await api.get("/breaks/me"); setActive(data.active); } catch (e) { /* offline */ }
  }, []);

  useEffect(() => {
    if (!staff) return undefined;
    refresh();
    const beat = () => api.post("/presence/heartbeat").catch(() => {});
    beat();
    const id = setInterval(() => { beat(); refresh(); }, 60000);
    return () => clearInterval(id);
  }, [staff, refresh]);

  const start = async (type) => {
    setBusy(true);
    try { const { data } = await api.post("/breaks/start", { type }); setActive(data); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); refresh(); } finally { setBusy(false); }
  };
  const end = async () => {
    setBusy(true);
    try { const { data } = await api.post("/breaks/end"); setActive(null); toast.success(`Welcome back! ${data.type} lasted ${fmtDur(data.duration_sec)}`); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); refresh(); } finally { setBusy(false); }
  };
  return <Ctx.Provider value={{ staff, active, busy, start, end }}>{children}</Ctx.Provider>;
}
